import { render } from "./IconX.vue.js?vue&type=template&id=68001eae!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconX.vue?vue&type=template&id=68001eae"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__